module.exports = __webpack_public_path__ + "static/img/s3a.31211c9e.jpg";